import { render, staticRenderFns } from "./SmsMarketing.vue?vue&type=template&id=5d93329a&scoped=true"
import script from "./SmsMarketing.vue?vue&type=script&lang=js"
export * from "./SmsMarketing.vue?vue&type=script&lang=js"
import style0 from "./SmsMarketing.vue?vue&type=style&index=0&id=5d93329a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d93329a",
  null
  
)

export default component.exports